// extracted by mini-css-extract-plugin
module.exports = {"block":"ImportAnnouncement_block__1z_ck","title":"ImportAnnouncement_title__FqIQQ"};